$shm_hitalama_map_page_arrows $mol_view
	Map_page $shm_hitalama_map_page
	visible true
	widget_arrows /$mol_view
	widget_arrow_from_widget* $shm_hitalama_map_widget_float
	widget_arrow_to_widget* $shm_hitalama_map_widget_float
	Widget_arrow* $shm_hitalama_map_page_arrow_widgets
		from_widget <= widget_arrow_from_widget*
		to_widget <= widget_arrow_to_widget*
		kind <= widget_arrow_kind* \
	Missing_relation* $mol_button_minor
		hint <= missing_relation_title* \
		sub / <= Missing_relation_icon* $mol_icon_plus
		click? <=> missing_relation_create*? null
		style *
			^
			position \absolute
			left <= missing_relation_left* \0px
			top <= missing_relation_top* \0px
			zIndex 2
